var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-base" },
    [
      _c("HeaderCentral", {
        attrs: {
          imageLogoSrc: require("@/assets/images/logo.png"),
          descricaoLogo: "Sistema de Cadastro e Regularização Fundiária"
        },
        scopedSlots: _vm._u([
          {
            key: "RightButtons",
            fn: function() {
              return [
                _c("ProfileButton", {
                  attrs: {
                    nameUser: _vm.getNomeUsuario,
                    namePerfil: _vm.getPerfil,
                    emailUser: "" + _vm.usuario.pessoa.email,
                    opcoesProfileButton: [
                      {
                        text: "Módulos",
                        action: function() {
                          return _vm.irParaSelecaoModulos()
                        }
                      }
                    ],
                    ButtonSair: {
                      text: "Sair",
                      action: function() {
                        return _vm.sair()
                      }
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main-container" },
        [
          _c("SideMenu", {
            attrs: {
              items: _vm.menuOptions,
              isActiveOnPreviousRoute: _vm.caixaIsActiveOnPreviousRoute
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { key: _vm.$route.fullPath, staticClass: "router-view-container" },
            [
              _vm.rotasNav
                ? _c("Nav", {
                    attrs: { routes: _vm.rotasNav },
                    on: { goHome: _vm.irParaSelecaoModulos }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("router-view"),
              _vm._v(" "),
              _vm._t("default")
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2862aa58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2862aa58","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/layout/LayoutBases/LayoutAnalise/LayoutAnalise.vue
// module id = null
// module chunks = 